'use strict';

var __makeTemplateObject =
  (void 0 && (void 0).__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', {
        value: raw,
      });
    } else {
      cooked.raw = raw;
    }

    return cooked;
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.StyledIconLeft =
  exports.StyledHint =
  exports.StyledIconButton =
  exports.StyledLabel =
  exports.StyledInput =
  exports.StyledContainer =
  exports.StyledRoot =
    void 0;

var styled_components_1 = __importDefault(require('styled-components'));

var components_1 = require('../../../constants/components');

var Typography_1 = __importDefault(require('../../Typography/Typography'));

var styledGenerators_1 = require('./styledGenerators');

exports.StyledRoot = styled_components_1.default.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  display: inline-block;\n  width: 100%;\n'],
      ['\n  display: inline-block;\n  width: 100%;\n']
    ))
);
exports.StyledContainer = styled_components_1.default.div(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      ['\n  position: relative;\n  line-height: 0;\n  z-index: 1;\n\n  ', ';\n'],
      ['\n  position: relative;\n  line-height: 0;\n  z-index: 1;\n\n  ', ';\n']
    )),
  styledGenerators_1.generateInputGeometricLine
);
exports.StyledInput = styled_components_1.default.input(
  templateObject_3 ||
    (templateObject_3 = __makeTemplateObject(
      [
        '\n  border: none;\n  outline: none;\n  background-color: transparent;\n  box-sizing: border-box;\n\n  width: 100%;\n  caret-color: ',
        ';\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ],
      [
        '\n  border: none;\n  outline: none;\n  background-color: transparent;\n  box-sizing: border-box;\n\n  width: 100%;\n  caret-color: ',
        ';\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ]
    )),
  function (_a) {
    var theme = _a.theme;
    return theme.transparent[100];
  },
  styledGenerators_1.generateInputFontSize,
  styledGenerators_1.generateInputHeight,
  styledGenerators_1.generateEllipsisContent,
  styledGenerators_1.generateInputView,
  styledGenerators_1.generateInputColor
);
exports.StyledLabel = styled_components_1.default.label(
  templateObject_4 ||
    (templateObject_4 = __makeTemplateObject(
      [
        '\n  width: 100%;\n  pointer-events: none;\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ],
      [
        '\n  width: 100%;\n  pointer-events: none;\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ]
    )),
  styledGenerators_1.generateLabelPosition,
  styledGenerators_1.generateLabelFontSize,
  styledGenerators_1.generateLabelFontColor,
  styledGenerators_1.generateEllipsisContent,
  styledGenerators_1.generateGap,
  styledGenerators_1.generateGapLeftRight
);
exports.StyledIconButton = styled_components_1.default.button(
  templateObject_5 ||
    (templateObject_5 = __makeTemplateObject(
      [
        '\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  outline: none;\n\n  position: absolute;\n  right: 0;\n  --webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n\n  @media not all and (hover: none) {\n    &:hover {\n      svg {\n        fill: ',
        ';\n      }\n    }\n  }\n\n  &:active {\n    svg {\n      fill: ',
        ';\n    }\n  }\n\n  z-index: 0;\n',
      ],
      [
        '\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  outline: none;\n\n  position: absolute;\n  right: 0;\n  --webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n\n  @media not all and (hover: none) {\n    &:hover {\n      svg {\n        fill: ',
        ';\n      }\n    }\n  }\n\n  &:active {\n    svg {\n      fill: ',
        ';\n    }\n  }\n\n  z-index: 0;\n',
      ]
    )),
  styledGenerators_1.generateIconButtonSize,
  styledGenerators_1.generateIconButtonPosition,
  styledGenerators_1.generateIconColor,
  function (_a) {
    var theme = _a.theme;
    return theme.transparent[100];
  },
  function (_a) {
    var theme = _a.theme;
    return theme.transparent[100];
  }
);
exports.StyledHint = styled_components_1.default(Typography_1.default)(
  templateObject_6 ||
    (templateObject_6 = __makeTemplateObject(
      [
        '\n  margin-top: ',
        ';\n  max-width: inherit;\n  word-break: break-word;\n\n  ',
        ';\n  ',
        ';\n',
      ],
      [
        '\n  margin-top: ',
        ';\n  max-width: inherit;\n  word-break: break-word;\n\n  ',
        ';\n  ',
        ';\n',
      ]
    )),
  function (_a) {
    var $size = _a.$size;
    return $size === components_1.INPUT_SIZES.medium ? '8px' : '4px';
  },
  styledGenerators_1.generateHintColor,
  styledGenerators_1.generateGap
);
exports.StyledIconLeft = styled_components_1.default.div(
  templateObject_7 ||
    (templateObject_7 = __makeTemplateObject(
      [
        '\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  outline: none;\n\n  cursor: text;\n\n  position: absolute;\n  left: 0;\n  --webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ],
      [
        '\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  outline: none;\n\n  cursor: text;\n\n  position: absolute;\n  left: 0;\n  --webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ]
    )),
  styledGenerators_1.generateIconButtonSize,
  styledGenerators_1.generateIconLeftPosition,
  styledGenerators_1.generateIconColor
);
var templateObject_1,
  templateObject_2,
  templateObject_3,
  templateObject_4,
  templateObject_5,
  templateObject_6,
  templateObject_7;
